module.exports = __webpack_public_path__ + "static/media/correct-answer.84b35c26.wav";